/* The project row an export reads — always the LIVE one.
   A snapshot captured at mount (a prop, a Designer load) goes stale the moment
   the Project tokens Sheet saves; the cloudCache row never does. */

type Row = Record<string, unknown> & { id?: string };

/** The newest copy of `snapshot`'s project: the live row when one exists, else the snapshot. */
export function latestProjectRow<T extends Row>(snapshot: T, liveRows: ReadonlyArray<Row>): T {
  const live = snapshot?.id ? liveRows.find((r) => r.id === snapshot.id) : undefined;
  return (live as T | undefined) ?? snapshot;
}

/** `ProjectToken:<id>` → resolved text for every token on the row, resolved against `base`. */
export function projectTokenMeta(
  row: Row | null | undefined,
  base: Record<string, string>,
  resolve: (content: string, meta: Record<string, string>) => string
): Record<string, string> {
  const out: Record<string, string> = {};
  const tokens = (row?.formaTokens as Array<{ id: string; content: string }> | undefined) || [];
  for (const pt of tokens) if (pt) out['ProjectToken:' + pt.id] = resolve(pt.content, base);
  return out;
}
